import { render, staticRenderFns } from "./MediaAboutUs.vue?vue&type=template&id=40e8fdf8&scoped=true&"
import script from "./MediaAboutUs.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MediaAboutUs.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MediaAboutUs.vue?vue&type=style&index=0&id=40e8fdf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e8fdf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e8fdf8')) {
      api.createRecord('40e8fdf8', component.options)
    } else {
      api.reload('40e8fdf8', component.options)
    }
    module.hot.accept("./MediaAboutUs.vue?vue&type=template&id=40e8fdf8&scoped=true&", function () {
      api.rerender('40e8fdf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/MediaAboutUs.vue"
export default component.exports